import React from 'react';
import './feedback.css'
import { supabase } from '../../supabase';
import { useState } from 'react';
import { useEffect} from 'react';
import Cta from './cta';
import pic25 from '../../assets/pic25.png'
import Circlenav from './circlenav-header';
import pic26 from '../../assets/pic26.png'


const Feedback = ({ onClose }) => {
const [rating, setRating] = useState(0);


 const [feedback, setfeedback]= useState([]);
      useEffect(() => {
      const getfeedback = async()=>{
          const res = await supabase.from('feedback_mobile').select('*').order('id', { ascending: true });;;
    
      setfeedback(res.data);
      }
      getfeedback();
      }, []);




    return ( 
        <section className='background-popup-feedback'>
            
            <section className='container-feedback-popup'>
                    <h1 className='header-popup'>{feedback?.[0]?.header}</h1>
                    <button className='cta-close-container'>
                    <Circlenav onClick={onClose}  icon={pic26} />
                    </button>
                    <p className='para-feedback'>{feedback?.[0]?.para}</p>
                        <figure className='container-stars-feedback'>
                        {[1, 2, 3, 4, 5].map((star) => (
                            <img
                            key={star}
                            src={pic25}
                            alt={`star`}
                            className={rating >= star ? 'star active' : 'star'}
                            onClick={() => setRating(star)}
                            /> ))}
                        </figure>
                    <Cta onClick={onClose} title={feedback?.[0]?.cta}/>
            </section>
        </section>
     );
}
 
export default Feedback;